import React from 'react';
import ConfirmationPopup from '../popup/confirmationpopup/ConfirmationPopup';
import { VEC_ICON_NAME } from '../icons/constants';
import FormEventHandlers from '../../../libs/utility/formeventhandlers/FormEventHandlers';
import { BUTTON_TYPE } from '../button/constants';

// import { resetUserInteractionPopupWResponseObj, setTempFormFieldsList, setInitialInteractionPopupWObj } from '../../CreateFormSlice';

export default function RenderInteractionElement({interactionObj, userInteractionPopupWResponseObj, updateFormFieldsCb = () => {}, resetUserInteractionPopupWResponseObjCb = () => {}, setInitialInteractionPopupWObjCb = () => {}}){

    switch(interactionObj?.type){
        case 'popup':
            switch(interactionObj?.runcondition){
                case 'onFormLoad':
                    return <ConfirmationPopup
                        title={"Are you sure?"}
                        bodyText={userInteractionPopupWResponseObj?.message}
                        iconName = {VEC_ICON_NAME.WARNING_ICON}
                        isOpen={(userInteractionPopupWResponseObj?.type === "popup") ? true : false}
                        confirmationButtonProps = {(userInteractionPopupWResponseObj?.positiveResponse) ? {
                            onConfirmationCb: () => FormEventHandlers.handleInitialRenderPopup(true, userInteractionPopupWResponseObj, () => setInitialInteractionPopupWObjCb()),
                            confirmationButtonText: userInteractionPopupWResponseObj?.positiveResponse?.buttonText,
                            confirmationButtonStyles: {},
                            confirmationButtonType: BUTTON_TYPE.PRIMARY,
                        } : null}
                        cancelButtonProps = {(userInteractionPopupWResponseObj?.negativeResponse) ? {
                            onCancelCb: () => FormEventHandlers.handleInitialRenderPopup(false, userInteractionPopupWResponseObj, () => setInitialInteractionPopupWObjCb()),
                            cancelButtonText: userInteractionPopupWResponseObj?.negativeResponse?.buttonText,
                            cancelButtonStyles: {},
                            cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
                        } : null }
                        showClose={false}
                    />
                case 'onload': 
                    return <ConfirmationPopup
                        title={"Are you sure?"}
                        bodyText={userInteractionPopupWResponseObj?.message}
                        iconName = {VEC_ICON_NAME.WARNING_ICON}
                        isOpen={(userInteractionPopupWResponseObj?.type === "popup") ? true : false}
                        confirmationButtonProps = {(userInteractionPopupWResponseObj?.positiveResponse) ? {
                            onConfirmationCb: () => FormEventHandlers.handleUserInteractionPopupBtnClick(true, userInteractionPopupWResponseObj, (updatedFieldsList) => updateFormFieldsCb(updatedFieldsList), () => resetUserInteractionPopupWResponseObjCb()),
                            confirmationButtonText: "Ok",
                            confirmationButtonStyles: {},
                            confirmationButtonType: BUTTON_TYPE.PRIMARY,
                        } : null}
                        cancelButtonProps = {(userInteractionPopupWResponseObj?.negativeResponse) ? {
                            onCancelCb: () => FormEventHandlers.handleUserInteractionPopupBtnClick(false, userInteractionPopupWResponseObj, (updatedFieldsList) => updateFormFieldsCb(updatedFieldsList), () => resetUserInteractionPopupWResponseObjCb()),
                            cancelButtonText: "Cancel",
                            cancelButtonStyles: {},
                            cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
                        } : null }
                        showClose={false}
                    />
                default:
                    return ""
            }
            
        default:
            return ""
    }
}